import { CmpCheck, loadScript, yieldToMainBackground } from "./utils";

export class MpVideoPlayer {
	constructor() {
		this.show_ads = null;
		this.ready = false;
		this.jwp = document.querySelector('meta[name="video-setup"]')?.content;
		this.plus_user = document.querySelector('meta[name="plus-user"]')?.content;
	}

	async init() {
		return new Promise((resolve, reject) => {
			loadScript(
				"jwplayer",
				`https://content.jwplatform.com/libraries/${this.jwp}.js`,
			).then(() => {
				const checkCmp = new CmpCheck();
				checkCmp.checkConsent().then((response) => {
					this.show_ads = response;
					this.ready = true;
					resolve(this.ready);
				});
			});
		});
	}

	// Setup JW Player
	setupPlayer(
		id,
		video_id,
		{
			no_ads = undefined,
			autostart = false,
			article_url = undefined,
			is_downloadable = undefined,
			width = undefined,
			height = undefined,
		} = {},
	) {
		//console.log(id);
		const config = {
			playlist: `https://cdn.jwplayer.com/v2/media/${video_id}`,
			autostart: autostart,
			skin: {
				name: "multi",
			},
		};

		if (width && height) {
			config.width = width;
			config.height = height;
		}
		if (no_ads === "true" || this.show_ads === false) {
			config.advertising = {};
		}
		// console.log(config);
		const player = jwplayer(id).setup(config);

		// download button
		if (is_downloadable === "true") {
			player.on("play", function (event) {
				player.addButton(
					//This portion is what designates the graphic used for the button
					"/static/img/download.svg",
					//This portion determines the text that appears as a tooltip
					"Download Video",
					//This portion designates the functionality of the button itself
					() => {
						const levels = player.getQualityLevels();
						const quality = player.getCurrentQuality();
						const quality_settings = levels[quality];
						let dw_label;
						if (quality_settings.label.toLowerCase() === "auto") {
							dw_label = "720";
						} else {
							dw_label = quality_settings.label.substring(
								0,
								quality_settings.label.length - 1,
							);
						}
						let source = "";
						player.getPlaylistItem().allSources.map((s) =>
							// biome-ignore format lint: reason=
							s.height == dw_label ? (source = s.file) : null,
						);
						window.open(source, "_blank");
					},
					//And finally, here we set the unique ID of the button itself
					"download",
				);
			});
		}

		// comments button
		if (article_url) {
			player.on("play", function (event) {
				this.addButton(
					//This portion is what designates the graphic used for the button
					"/static/img/commenti.svg",
					//This portion determines the text that appears as a tooltip
					"Commenta",
					//This portion designates the functionality of the button itself
					() => {
						window.location.href = article_url;
					},
					//And finally, here we set the unique ID of the button itself
					"comments",
				);
			});
		}
		return player;
	}
}

// Display video player in a lightbox
function ajax_lightbox_player(element, video_container, multiJWP) {
	fetch(element.dataset.href, {
		headers: {
			"X-Requested-With": "XMLHttpRequest",
		},
	})
		.then((response) => response.text())
		.then((data) => {
			video_container.innerHTML = data;
			const video_player = video_container.querySelector("._player-video");
			const video_id = video_player.id;
			const jw_video_id = video_player.dataset.jw_video_id;
			const noads = video_player.dataset.noads;
			const autostart = video_player.dataset.autostart;
			const player = multiJWP.setupPlayer(video_id, jw_video_id, {
				noads: noads,
				autostart: autostart,
			});
			import("basiclightbox").then((basicLightbox) => {
				const lightbox = basicLightbox.create(video_container, {
					className: "basicLightbox--video-content",
					onShow: (instance) => {
						player.play();
					},
				});
				lightbox.show();
			});
		})
		.catch((error) => {
			console.warn(error);
		});
}

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const multiJWP = new MpVideoPlayer();
	multiJWP.init().then((is_ready) => {
		if (!is_ready) {
			return;
		}

		document.body.addEventListener("click", (event) => {
			// video con lightbox
			if (event.target?.classList.contains("_lightbox_video")) {
				event.preventDefault();
				yieldToMainBackground().then(() => {
					ajax_lightbox_player(
						event.target,
						event.target.nextElementSibling,
						multiJWP,
					);
				});
			}
		});

		// video in page
		for (const el of document.querySelectorAll("._player-video")) {
			yieldToMainBackground().then(() => {
				const video_id = el.id;
				const jw_video_id = el.dataset.jw_video_id;
				const noads = el.dataset.noads;
				const autostart = el.dataset.autostart;
				const comments_url = el.dataset.comments_url;
				const is_downloadable = el.dataset.is_downloadable;
				const width = el.dataset.width;
				const height = el.dataset.height;
				multiJWP.setupPlayer(video_id, jw_video_id, {
					noads: noads,
					autostart: autostart,
					article_url: comments_url,
					is_downloadable: is_downloadable,
					width: width,
					height: height,
				});
			});
		}
	});
});
